module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('l-geo-json', {
    ref: "geolayer",
    attrs: {
      "geojson": _vm.geojsonData.geojson,
      "options": _vm.geojsonOptions
    }
  }), _vm._v(" "), _vm._t("default", null, {
    "currentItem": _vm.currentItem,
    "unit": _vm.value.metric,
    "min": _vm.min,
    "max": _vm.max
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-030f777e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChoroplethLayer.vue
// module id = 61
// module chunks = 0